import axios from 'axios';
import { LocalStorage } from 'quasar';
import constants from '../../common/constants';
import RoleService from '../../common/api/role.service';

export async function fetchAllUsers({ commit }) {
  const response = await RoleService.get(constants.USER_ROLE_ID);
  if (response.status === 200) {
    commit('updateAllUsers', { users: response.data.users });
  }
}

export async function updateCurrentUser({ commit, dispatch }, { user }) {
  if (user) {
    dispatch('updateAccessToken', { accessToken: user.accessToken });
    commit('updateCurrentUser', { user });
  }
}

export async function updateCurrentUserFromStorage({ dispatch }) {
  if (LocalStorage.has('user')) {
    dispatch('updateCurrentUser', { user: LocalStorage.getItem('user') });
  }
}

export async function storeCurrentUser({ state }) {
  if (state.current) {
    LocalStorage.set('user', state.current);
  }
}

export async function updateAccessToken(context, { accessToken }) {
  axios.defaults.headers.common['X-Access-Token'] = accessToken;
}

export async function flush({ commit }) {
  commit('flush');
}
